import styles from './styles.module.scss';


export default function Card({feedback,deletarFeedback,type}) {
    return (
        <div className={`${styles.card} ${type == 'erro'? styles.erro : styles.acerto}`}>
            <p>{feedback.message}</p>
            <button onClick={() => deletarFeedback(feedback.id)} className={styles.delete}>Deletar</button>

        </div>

    )

}